import React, { Component } from "react";
import {
    Form,
    Select,
    Button,
    Input,
    DatePicker,
    TimePicker,
    Modal,
    Checkbox,
    Upload,
    Row,
    Col,
    Space,
    message,
    Table,
    Card,
    Tooltip,
    Spin,
    Popconfirm,
    Collapse
} from "antd";
import { Autocomplete } from "@react-google-maps/api";
import { MapContainer, Marker, TileLayer } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import ReactLeafletGoogleLayer from "react-leaflet-google-layer";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import withRouter from "../withRouter";

import config from "../config";
import { format, addMinutes } from "date-fns";
import { Link } from "react-router-dom";
import CompanyAutocomplete from "./CompanyAutocomplete";
import GoogleMapForDirection from "./GoogleMapForDirection";
// import { useGoogleMapRef  } from "./GoogleMapForDirection";
import assignJobOrderStore from "../store/AssignJobOrderStore";

import dayjs from "dayjs";
import CompanyStore from "../store/CompanyStore";
import DeleteConfirm from "./DeleteConfirm";
import L from "leaflet";
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import {
    CloseOutlined,
    DeleteFilled,
    DeleteOutlined,
    PlusOutlined,
    PlusCircleOutlined,
    ExclamationCircleFilled,
    QuestionCircleOutlined
} from "@ant-design/icons";
import axios from "axios";
import AssignRouteStore from "../store/AssignRouteStore";
const inputStyle = {
    boxSizing: "border-box",
    border: "1px solid transparent",

    height: "32px",
    padding: "0 12px",
    borderRadius: "3px",
    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.3)",
    fontSize: "14px",
    outline: "none",
    textOverflow: "ellipses",
    // position: "absolute",
    left: "50%",
    // marginLeft: "-120px",
};

const formCss = {
    width: "285px",
    background: "rgb(255, 255, 255)",
    margin: "20px",
    padding: "13px",
    border: "1px solid",
    height: "620px",
    "overflow-y": "scroll",
};

const getDragItems = () => {
    return (
        [
            { id: "1", point: "Point 1", address: "", lat: "", lng: "", searchAddress: "", dateTimeRange: "" },
            { id: "2", point: "Point 2", address: "", lat: "", lng: "", searchAddress: "", dateTimeRange: "" },
        ]
    )
};

class AssignJobOrderAddNew extends Component {
    formRef = React.createRef();
    constructor(props) {
        super(props);

        this.state = {
            pointsWay: [],
            companyId: "",
            loadList: 0,
            offset: "",
            limit: "",
            geofence: "",
            searchOnMap: true,
            history: "",
            defaultAddValue: "searchOnMap",
            fromDate: dayjs(),
            toDate: dayjs(),
            fromTime: "",
            toTime: "",
            vehicleId: "",
            routePoints: [],
            startPoint: true,  //false
            endPoint: false,
            pickUpDrop: false,
            startObj: "",
            endObj: "",
            loadState: 0,
            origin: null,
            destination: null,
            companyCustomer: false,
            studentCustomer: false,
            addAddress: true,
            stId: "",
            pickUpDropObj: {},
            endTimeShowingTbl: "00:00",
            addressInputText: "",
            routePopupShow: false,
            geofencePointsArrayObj: [],
            clearMapBtn: false,
            routeDeviationAlert: true,
            geofenceInfoObj: {},
            geofenceFormatedPoints: [],
            tripId: "",
            dayofweeks: [],
            historyInfoObj: {},
            positionLatLongArray: [],
            loadingSpinner: false,
            wayPointId: 1,
            travelDistance: "",
            dragItems: [],
            pointName: "Point 1",
            selectedItemId: "1",
            pointNameInput: "", // New state to track the input value
            zoomLevel: 5,
            sourcesList: [],
            vehicleList: [],
            driverList: [],
            deviceGroupList: [],
            assignedDriversList: [],  // for main driver options
            mainDriver: null,         // selected main driver
            driversDisabled: false,
            mainDriverDisabled: false,
            driverRequired: true,
            travelHours: 0,
            travelMinutes: 0,
            markerToDelete: null,
            originAddress: null,
            destinationAddress: null
        };
        this.originRef = React.createRef();
        this.autocompleteRef = React.createRef();
        this.googleMapRef = React.createRef();
        this.mapRef = React.createRef();
        this.scrollRef = React.createRef();
        this.assignJobOrderStore = new assignJobOrderStore(this);
        this.AssignRouteStore = new AssignRouteStore(this);
        this.companyStore = new CompanyStore(this);
    }
    onSequenceTableRecordDelete = async (record) => {
        console.log(record, "ca");

        if (record.sequenceId) {
            if (Number(record.sequenceId) === 1) {
                console.log("called");
                this.setState({ origin: null, startObj: "" });
            } else if (Number(record.sequenceId) === 2) {
                this.setState({ destination: null, endObj: "" });
            }
            const filterRecord = this.state.routePoints.filter((val) => {
                return Number(record.sequenceId) !== Number(val.sequenceId);
            });
            await this.setState({ routePoints: filterRecord });
            if (this.state.geofencePointsArrayObj?.length > 0) {
                let filterGeofence = await this.state.geofencePointsArrayObj.filter(
                    (val) => {
                        return Number(record.sequenceId) !== Number(val.sequenceId);
                    }
                );
                await this.setState({ geofencePointsArrayObj: filterGeofence });
                console.log(filterGeofence, this.state.geofencePointsArrayObj, record);
            }
            console.log(filterRecord);
        } else if (Number(record.wayPointId)) {
            console.log(record);
            const filterRecord = this.state.routePoints.filter((val) => {
                return Number(record.wayPointId) !== Number(val.wayPointId);
            });
            await this.setState({ routePoints: filterRecord });
            const pointsWay = this.state.pointsWay.filter((val) => {
                return Number(record.wayPointId) !== Number(val.wayPointId);
            });
            // pointsWay
            console.log(pointsWay);
            await this.setState({ pointsWay: pointsWay });
        }

        // this.setState({
        //   origin: "",
        //   destination: "",
        //   pointsWay: [],
        //   clearMapBtn: true,
        // });
    };

    layout = {
        labelCol: { span: 16 },
        wrapperCol: { span: 16 },
    };

    async componentDidMount() {
        this.setState({ companyCustomer: true });
        // this.setState({ dragItems: getDragItems() });
        this.formRef.current.setFieldsValue({ pointName: "Point 1" });

        this.columns = [
            {
                title: "Sequence No",
                dataIndex: "sequenceNo",
                key: "sequenceNo",
            },
            {
                title: "PickUp Time",
                dataIndex: "picktime",
                key: "age",
            },
            {
                title: "Action",
                dataIndex: "",
                key: "",
                render: (_, record) => {
                    return (
                        <>
                            <Space>
                                <DeleteConfirm
                                    onConfirm={(e) => {
                                        // this.onDelete(record);
                                        console.log(record);
                                        this.onSequenceTableRecordDelete(record);
                                    }}
                                >
                                    <Link
                                        onClick={(e) => {
                                            e.preventDefault();
                                        }}
                                    >
                                        <DeleteFilled style={{ color: config.deleteColor }} />
                                    </Link>
                                </DeleteConfirm>
                            </Space>
                        </>
                    );
                },
            },
        ];
        const id = this.props.params.id;
        const companyId = this.props.params.companyId

        if (
            Number(this.props.getUserData().isadmin) !== -1 &&
            Number(this.props.getUserData().isadmin) !== 3
        ) {
            await this.setState({
                companyId: this.props.getUserData().userCompanyId,
            });

            const vehicleList = await this.assignJobOrderStore.getVehicles(this.state.companyId);
            const driverList = await this.assignJobOrderStore.getDrivers(this.state.companyId);
            const deviceGroupList = await this.assignJobOrderStore.getDeviceGroups(this.state.companyId);

            this.setState({
                vehicleList: vehicleList || [],
                driverList: driverList || [],
                deviceGroupList: deviceGroupList || []
            });

        }
        if (id) {
            this.filldata(id, companyId);
        }
    }

    componentDidUpdate() {
        setTimeout(() => {
            window.dispatchEvent(new Event("resize"));
        });
    }
    filldata = async (id, companyId) => {
        try {
            // debugger
            await this.setState({ loadingSpinner: true });
            // const prevCompanyId = this.context.viewStateStore.assignJobOrderObject.companyId;
            const record = await this.assignJobOrderStore.getJobOrderById(companyId, id);
            console.log(record, "record");
            await this.setState({ routeId: record.stId, companyId: record.companyId });

            const singleData = await this.companyStore.getCompanyDataById(
                record.companyId
            );
            const vehicleList = await this.assignJobOrderStore.getVehicles(record.companyId);
            const driverList = await this.assignJobOrderStore.getDrivers(record.companyId);
            const deviceGroupList = await this.assignJobOrderStore.getDeviceGroups(record.companyId);
            await this.setState({
                vehicleList: vehicleList || [],
                driverList: driverList || [],
                deviceGroupList: deviceGroupList || []
            });

            /** -----------------------------
             * 1. SET COMPANY + LOAD VEHICLES/DRIVERS FIRST
             * ----------------------------- **/
            // await this.setState({  });
            // await this.handleChange({ value: record.companyId });

            await this.handleStopsSourceChange(record.stopSource)

            /** -----------------------------
             * 2. CONVERT DRIVER STRING → ARRAY
             * ----------------------------- **/
            const assignedDrivers = record.assignDriverIds
                ? record.assignDriverIds.split(",").map((x) => Number(x))
                : [];

            /** MAIN + SECONDARY DRIVER **/
            const mainDriver = Number(record.driverId) || null;
            const secondaryDriver = Number(record.secondaryDriverIds) || null;

            // debugger
            const unitsArray = record.unitId
                ? String(record.unitId).split(',').map(x => Number(x.trim()))
                : [];
            if (unitsArray.length > 1) {
                this.setState({ driverRequired: false });
            }
            // debugger
            let mainDriverOptions = driverList.filter((d) =>
                assignedDrivers.includes(d.driverId)
            );


            /** -----------------------------
             * 3. Bind Form Data
             * ----------------------------- **/
            this.formRef.current.setFieldsValue({
                account: singleData,
                tripName: record.tripName,

                plannedStartDateTime: record.routestartDate
                    ? dayjs(record.routestartDate)
                    : null,

                plannedEndDateTime: record.routestopDate
                    ? dayjs(record.routestopDate)
                    : null,

                //unitGroup: record.unitgroup,
                units: unitsArray,                    // API gives only 1 unit

                assignedDrivers: assignedDrivers,          // converted array
                mainDriver: mainDriver,                    // main driver
                stopSource: record.stopSource,             // ["2"]
                tripStatus: Number(record.tripStatus)
                // tripStatus: record.tripStatus == 1 
                //   ? "Assigned by Admin" 
                //   : "Allocate to Driver",
            });

            /** -----------------------------
             * 4. CREATE mainDriverStore OPTIONS
             * 
             * ----------------------------- **/


            await this.setState({
                assignedDriversList: mainDriverOptions,
                mainDriverStore: mainDriverOptions,
                mainDriver: mainDriver,
                secondaryDriver: secondaryDriver
            });

            /** -----------------------------
             * 5. LOAD ROUTE POINTS ON MAP
             * ----------------------------- **/
            if (record.RoutePoints?.length) {
                let list = [];
                let markers = [];
                let wp = [];

                record.RoutePoints.forEach((p, index) => {
                    const obj = {
                        id: String(index + 1),
                        point: p.pointName || "Point " + (index + 1),
                        address: p.address,
                        lat: Number(p.latitude),
                        lng: Number(p.longitude),
                        searchAddress: "Route"
                    };

                    list.push(obj);
                    markers.push({ lat: obj.lat, lng: obj.lng });
                    this.setState({ travelDistance: p.travelDistance, travelTime: p.travelDuration });
                });

                // SET ORIGIN & DESTINATION CORRECTLY
                const origin =
                    list.length >= 1 ? { lat: list[0].lat, lng: list[0].lng } : null;

                const destination =
                    list.length >= 2
                        ? {
                            lat: list[list.length - 1].lat,
                            lng: list[list.length - 1].lng
                        }
                        : null;

                // SET ADDRESSES
                const originAddress =
                    list.length >= 1 ? list[0].address : null;

                const destinationAddress =
                    list.length >= 2 ? list[list.length - 1].address : null;

                // WAYPOINTS = ALL MIDDLE POINTS
                const wpList =
                    list.length > 2
                        ? list.slice(1, list.length - 1).map((obj, index) => ({
                            location: { lat: obj.lat, lng: obj.lng },
                            wayPointId: index + 1,
                            address: obj.address
                        }))
                        : [];

                // UPDATE STATE
                this.setState({
                    dragItems: list,
                    positionLatLongArray: markers,
                    origin,
                    destination,
                    originAddress,
                    destinationAddress,
                    pointsWay: wpList
                });

                setTimeout(() => {
                    this.mapRef.current?.fitToMarkers?.();
                }, 300);
            }
            // if (record.RoutePoints?.length) {
            //   let list = [];
            //   let markers = [];
            //   let wp = [];
            //   let origin = null;
            //   let destination = null;
            //   let originAddress =null;
            //   let destinationAddress =null;

            //   record.RoutePoints.forEach((p, index) => {
            //     const obj = {
            //       id: String(index + 1),
            //       point: "Point " + (index + 1),
            //       address: p.address,
            //       lat: Number(p.latitude),
            //       lng: Number(p.longitude),
            //       searchAddress: "Route"
            //     };

            //     list.push(obj);
            //     markers.push({ lat: obj.lat, lng: obj.lng });

            //     if (index === 0) origin = { lat: obj.lat, lng: obj.lng };

            //     else if (index === 1) destination = { lat: obj.lat, lng: obj.lng };
            //     else {
            //       wp.push({
            //         location: { lat: obj.lat, lng: obj.lng },
            //         wayPointId: index,
            //         address:obj.address
            //       });
            //     }
            //   });

            //   this.setState({
            //     dragItems: list,
            //     positionLatLongArray: markers,
            //     origin,
            //     destination,
            //     pointsWay: wp,
            //   });

            //   setTimeout(() => {
            //     this.mapRef.current?.fitToMarkers?.();
            //   }, 300);
            // }

            /** -----------------------------
             * 6. DISABLE FIELDS IF MULTIPLE UNITS
             * ----------------------------- **/
            this.updateUnitDriverDisableState(unitsArray);

            await this.setState({ loadingSpinner: false });

        } catch (err) {
            console.log("Error in filldata:", err);
        }
    };

    async handleChange(comp) {
        console.log(comp.value);
        await this.setState({ companyId: comp.value });
        await this.formRef.current.setFieldsValue({ companyId: comp.value });

        const vehicleList = await this.assignJobOrderStore.getVehicles(comp.value);
        const driverList = await this.assignJobOrderStore.getDrivers(comp.value);
        const deviceGroupList = await this.assignJobOrderStore.getDeviceGroups(comp.value);

        this.setState({
            vehicleList: vehicleList || [],
            driverList: driverList || [],
            deviceGroupList: deviceGroupList || []
        });

        await this.handleSearch();
    }

    async handleSearch() {
        await this.assignJobOrderStore.loadData({
            offset: (this.state.currentPage - 1) * this.state.pageSize,
            limit: this.state.pageSize,
            searchField: this.state.searchField,
            companyId: this.state.companyId
        });
        await this.setState({ loadList: 1 });
    }

    onFinish = async (values) => {
        if (values.tripStatus == 2) {
            const canSave = await this.checkTripOverride(values);
            if (canSave) {
                await this.actualSaveProcess(values);
            }
        } else {
            await this.actualSaveProcess(values);
        }
    };
    actualSaveProcess = async (values) => {

        try {
            await this.setState({ loadingSpinner: true });
            let AddRoute = {};
            const user = this.props.getUserData();

            /** ROUTE ID **/
            AddRoute.stId = this.state.routeId != null ? this.state.routeId : -1;

            /** COMPANY ID **/
            if (user.issuperadmin == 1 || user.isadmin == 3) {
                AddRoute.companyId = this.state.companyId;
            } else {
                AddRoute.companyId = user.userCompanyId;
            }

            AddRoute.userId = user.userId;
            AddRoute.isadmin = user.isadmin;

            /** BASIC FIELDS **/
            AddRoute.tripName = values.tripName;
            AddRoute.tripStatus = values.tripStatus;
            AddRoute.SourceName = values.stopSource;
            AddRoute.unitgroup = values.unitgroup;
            AddRoute.unit = values.units || [];
            AddRoute.assignDrivers = values.assignedDrivers || [];
            AddRoute.mainDriver = values.mainDriver || null;

            /** SECONDARY DRIVER **/
            let secondaryDriver = null;

            if (values.assignedDrivers && values.assignedDrivers.length > 0) {
                const nonMainDrivers = values.assignedDrivers.filter(
                    (dId) => dId !== values.mainDriver
                );

                if (nonMainDrivers.length > 0) {
                    secondaryDriver = nonMainDrivers[0]; // first non-main driver
                }
            }

            AddRoute.secondaryDriver = secondaryDriver;

            /** DATE + TIME FORMAT **/
            const formatDate = (dtStr) => {
                const dt = dayjs(dtStr, "DD-MM-YYYY hh:mm A");
                return dt.format("YYYY-MM-DD HH:mm:ss");
            };

            AddRoute.plannedStartDateTime = formatDate(values.plannedStartDateTime);
            AddRoute.plannedEndDateTime = formatDate(values.plannedEndDateTime);

            /** ROUTE POINTS **/
            let routePoints = [];
            console.log("Drag Items:", this.state.dragItems);
            debugger
            this.state.dragItems.forEach((item, index) => {
                const obj = {};
                console.log("Processing item:", item);

                obj.routeZoneId =
                    item.routeZoneId || "ext-gen" + Math.floor(Math.random() * 9000 + 1000);

                // obj.pointName = item.name;
                obj.pointName = item.point;
                // obj.pointName = item.address;
                obj.travelDistance = Number(item.travelDistance || 0);
                obj.travelDuration = Number(item.travelDuration || 0);


                obj.sequenceNo =
                    item.point && item.address
                        ? item.point + "-" + item.address
                        : item.address;

                obj.picktime = item.calculatedPickUpTime || "";
                obj.address = item.address || "";
                obj.lati = item.lat || "";
                obj.longi = item.lng || "";

                routePoints.push(obj);
            });

            /** AUTO CALCULATE END DATE (same as ExtJS) **/
            /*if (routePoints.length > 0) {
              const last = routePoints[routePoints.length - 1];
              const hours = Math.floor(last.travelDuration / 3600);
              const minutes = Math.round((last.travelDuration % 3600) / 60);
        
              let endDt = dayjs(AddRoute.plannedStartDateTime)
                .add(hours, "hour")
                .add(minutes, "minute");
        
              AddRoute.plannedEndDateTime = endDt.format("YYYY-MM-DD HH:mm:ss");
            }*/

            console.log("FINAL PAYLOAD:", { AddRoute, routePoints });

            /** API CALL **/
            const resp = await this.assignJobOrderStore.saveRoute({
                AddRoute,
                routePoints,
            });
            /** SUCCESS **/
            if (resp?.data?.success === "S") {
                await this.setState({ loadingSpinner: false });

                if (resp?.data?.data.repeatVehicles && resp?.data?.data.repeatVehicles.length > 0) {
                    message.error("Cant create trip for following vehicles as trips created for same timing. " + resp?.data?.data.repeatVehicleNos.join(', '));
                    return;
                }

                const isEdit = this.state.routeId && this.state.routeId !== -1;

                if (isEdit) {
                    message.success("Trip updated successfully");
                } else {
                    message.success("Trip created successfully");
                }
                this.context.viewStateStore.setAssignJobOrderStates({
                    companyId: this.state.companyId
                });


                /** RESET FORM **/
                this.formRef?.current?.resetFields();

                this.setState({
                    dragItems: [],
                    selectedItemId: null,
                    origin: null,
                    destination: null,
                    pointsWay: [],
                    positionLatLongArray: [],
                    geofencePointsArrayObj: [],
                    travelDistance: "",
                    travelTime: "",
                });

                this.props.navigate("/assignjoborderlist");
            } else {
                await this.setState({ loadingSpinner: false });
                message.error("Failed to save trip");
            }
        } catch (err) {
            await this.setState({ loadingSpinner: false });
            console.log("Error =>", err);
            message.error("Something went wrong");
        }


    };
    checkTripOverride = async (values) => {
        const resp = await this.assignJobOrderStore.getTripList(values.mainDriver, this.state.companyId);

        if (resp?.data?.[0]?.tripStatus === 3) {
            return new Promise((resolve) => {
                Modal.confirm({
                    title: "Alert",
                    content: "A trip is already selected by this driver. Do you want to override?",
                    onOk: () => resolve(true),
                    onCancel: () => resolve(false),
                });
            });
        }

        return true;
    };
    handleAddressChange = (val) => {
        if (val === "geofence") {
            this.setState({ geofence: true, searchOnMap: false, history: false });
        } else if (val === "searchOnMap") {
            this.setState({ geofence: false, searchOnMap: true, history: false });
        } else if (val === "history") {
            this.setState({ geofence: false, searchOnMap: false, history: true });
        }
    };

    timeOptions = () => {
        const timeArray = [];

        let startTime = new Date(2000, 0, 1, 0, 0); // 12:00 AM
        console.log();
        let endTime = new Date(2000, 0, 1, 23, 30);
        for (let time = startTime; time <= endTime; time = addMinutes(time, 30)) {
            // const formattedTime = format(time, 'h:mm aa');
            const formattedTime = format(time, "HH:mm:ss");
            var ob = {
                formattedTime: formattedTime,
                time: time,
            };
            timeArray.push(ob);
        }
        console.log(timeArray);
        return timeArray.map((data) => {
            return (
                <Select.Option key={data.formattedTime} value={data.formattedTime}>
                    {format(data.time, "h:mm aa")}
                </Select.Option>
            );
        });
    };
    LoadClick = async () => {
        const data = {
            companyId: this.state.companyId,
            vehicleId: this.state.vehicleId,
            fromDate:
                this.state.fromDate.format("YYYY-MM-DD") + " " + this.state.fromTime,
            toDate: this.state.toDate.format("YYYY-MM-DD") + " " + this.state.toTime,
        };
        console.log(data);
        const response = await this.assignJobOrderStore.getStopeIdle(data);
        if (response?.data?.success === "S") {
            message.success(response.data.message);
            console.log(response);
        } else {
            message.error();
        }
        this.setState({ update: 1 });
        console.log(data);
    };

    handlePlaceSelected = async (placeDetails) => {
        console.log('handlePlaceSelected');
        //await this.setState({ routePoints: []});
        let routePoints = [];

        var firstRec = this.state.dragItems[0];


        if (firstRec.address) {
            const obj1 = {
                sequenceId: 1,
                routeZoneId: "ext-gen4321",
                routePoint: firstRec.searchAddress,
                sequenceNo: "Start Point- " + firstRec.address,
                address: firstRec.address,
                lati: firstRec.lat,
                longi: firstRec.lng,
                arriveTime: null,
                departureTime: dayjs(this.formRef.current.getFieldValue("startTime")).format("HH:mm"),
                startTime: dayjs(this.formRef.current.getFieldValue("startTime")).format("HH:mm"),
                endTime: null,
                locOption: "Start-Time",
                time: dayjs(this.formRef.current.getFieldValue("startTime")).format("HH:mm"),
                pointName: firstRec.point,
            };
            this.setState({ startObj: obj1 });

            routePoints.push(obj1);

            //await this.setState({ routePoints: [...this.state.routePoints, obj1] });

        }


        var middlePoints = this.state.dragItems.slice(1, -1);


        if (middlePoints.length > 0) {

            middlePoints.forEach(async (record, index) => {

                const obj2 = {
                    routeZoneId: "ext-gen2264" + index,
                    routePoint: record.searchAddress,
                    sequenceNo: "PickUp Point- " + record.address,
                    address: record.address,
                    lati: record.lat,
                    longi: record.lng,
                    arriveTime: this.formRef.current.getFieldValue("arriveTime"),
                    departureTime: this.formRef.current.getFieldValue("departureTime"),
                    endTime: null,
                    time: "00:00",
                    locOption: "Pickup/DropTime",
                    pointName: record.point,
                    wayPointId: index + 1
                };

                this.setState({ pickUpDropObj: obj2 });

                routePoints.push(obj2);



            });

        }
        var lastRec = this.state.dragItems[this.state.dragItems.length - 1];

        if (lastRec.address) {
            const obj3 = {
                sequenceId: 2,
                routeZoneId: "ext-gen2264",
                routePoint: lastRec.searchAddress,
                sequenceNo: "End Point- " + lastRec.address,
                address: lastRec.address,
                lati: lastRec.lat,
                longi: lastRec.lng,
                arriveTime: null,
                departureTime: null,
                endTime: dayjs(this.formRef.current.getFieldValue("endTime")).format("HH:mm"),
                time: dayjs(this.formRef.current.getFieldValue("endTime")).format("HH:mm"),
                locOption: "End-Time",
                pointName: lastRec.point,
            };

            this.setState({ endObj: obj3 });

            routePoints.push(obj3);

        }

        await this.setState({ routePoints: routePoints });

        console.log("routePoints", routePoints);
        console.log("routes**", this.state.routePoints);
        console.log("pickUpDropObj**", this.state.pickUpDropObj);
        console.log("startObj**", this.state.startObj);
        console.log("endObj**", this.state.endObj);

    };

    handleSequenceChange = (val) => {
        // startPoint,endpoint,pickup/drop
        if (val === "startPoint") {
            this.setState({ startPoint: true, endPoint: false, pickUpDrop: false });
        } else if (val === "endPoint") {
            if (!this.state.origin) {
                // Modal.warning({ content: "Please Select Start Point First" });
                Modal.warning({
                    content: this.context.translate("_PLEASE_SELECT_START_POINT_FIRST_"),
                });
            } else {
                this.setState({ startPoint: false, endPoint: true, pickUpDrop: false });
            }
        } else if (val === "pickup/drop") {
            if (!this.state.origin) {
                // Modal.warning({ content: "Please Select Start Point First" });
                Modal.warning({
                    content: this.context.translate("_PLEASE_SELECT_START_POINT_FIRST_"),
                });
            } else {
                this.setState({ startPoint: false, endPoint: false, pickUpDrop: true });
            }
        }
    };

    addSequenceIntoTable = async () => {
        // console.log(this.state.startObj, this.state.endObj);
        // console.log(this.state.startObj);
        if (!this.state.startObj) {
            Modal.warning({ content: "Please Select Start Point and address." });
        }
        console.log(this.state.startObj);
        let startObj = this.state.startObj;
        console.log(this.state.startObj);
        let endObj = this.state.endObj;
        let pickUpDrop = this.state.pickUpDrop;
        console.log(this.state.endObj, this.state.startObj);
        console.log(pickUpDrop, startObj, endObj);
        // await this.setState({routePoints:[...this.state.routePoints,startObj,endObj,pickUpDrop]})
        if (this.state.companyId) {
            let arr;
            if (this.state.endPoint) {
                console.log(this.state.routePoints, "hello");
                arr = [...this.state.routePoints, endObj];
                console.log(endObj);
                await this.setState({
                    routePoints: arr,
                    destination: { lat: endObj.lati, lng: endObj.longi },
                });
                // this.setState({ endObj: "", });
            } else if (this.state.startPoint) {
                arr = [startObj];
                console.log(startObj);
                await this.setState({
                    routePoints: arr,
                    origin: { lat: startObj.lati, lng: startObj.longi },
                });
            } else if (this.state.pickUpDrop) {
                arr = [...this.state.routePoints, this.state.pickUpDropObj];
                console.log(arr);
                await this.setState({
                    routePoints: arr,
                    // origin: {
                    //   lat: this.state.pickUpDropObj?.lati,
                    //   lng: this.state.pickUpDropObj?.longi,
                    // },
                });
            }
            console.log(arr);
            await this.setState({ addressInputText: "" });
        } else {
            Modal.warning({
                // title: "Alert",
                title: this.context.translate("_FLEET_ALERT_"),
                // content: "Please select Account",
                content: this.context.translate("_PLEASE_SELECT_ACCOUNT_"),
            });
        }
        console.log(this.state.routePoints);
        this.setState({ update: 1 });
    };
    selectCustomer = (val) => {
        if (val === "company") {
            this.setState({ companyCustomer: true, studentCustomer: false });
        } else {
            this.setState({ companyCustomer: false, studentCustomer: true });
        }
    };

    placeChange = async () => {
        if (this.originRef.current) {
            const place = this.originRef.current.getPlace();

            if (place.geometry && place.geometry.location) {
                const lat = place.geometry.location.lat();
                const lng = place.geometry.location.lng();
                await this.setState({
                    positionLatLongArray: [
                        ...this.state.positionLatLongArray,
                        { lat: lat, lng: lng },
                    ]
                });


                if (this.state.selectedItemId == "2") {
                    this.setState({ destination: { lat: lat, lng: lng } });
                }
                else if (this.state.selectedItemId == "1") {
                    this.setState({ origin: { lat: lat, lng: lng } });
                }




                // if (this.state.endPoint) {
                //   this.setState({ destination: { lat: lat, lng: lng } });
                // } else if (this.state.startPoint) {
                //   this.setState({ origin: { lat: lat, lng: lng } });
                // }
                console.log("Formatted Address:", place.formatted_address);
                console.log("Latitude:", lat);
                console.log("Longitude:", lng);
                const addressObject = {
                    formattedAddress: place.formatted_address,
                    latitude: lat,
                    longitude: lng
                };
                this.setState({ addressInputText: place.formatted_address });
                //this.handlePlaceSelected(addressObject);
                this.handlePointsAddressChange(addressObject, "call");



            } else {
                console.log("Location information not available.");
            }
        }
    };
    handleGeofenceObj = async (record) => {
        // debugger
        if (record.type === "geofence") {
            const arr = record.points.split(",");
            const lat = Number(arr[0]);
            const lng = Number(arr[1]);

            await this.addPointToMap({
                lat,
                lng,
                address: record.address,
                type: "Geofence",
                name: record.name
            });

            return;
        }
        if (record.type === "route") {
            const routePoints = record.routePoints || [];

            for (let i = 0; i < routePoints.length; i++) {
                debugger
                const p = routePoints[i];

                const lat = Number(p.latitude);
                const lng = Number(p.longitude);

                await this.addPointToMap({
                    lat,
                    lng,
                    address: p.address,
                    type: "Route",
                    name: p.sequenceNo.split("-")[0].trim()
                });
            }

            return;
        }

        if (record.type === "poi") {
            const arr = record.points.split(",");
            const lat = Number(arr[0]);
            const lng = Number(arr[1]);

            await this.addPointToMap({
                lat,
                lng,
                address: record.address,
                type: "Geofence",
                name: record.name
            });

            return;
        }



        // Add marker always
        /* await this.setState({
           positionLatLongArray: [
             ...this.state.positionLatLongArray,
             { lat, lng }
           ]
         });
     
         // BUILD POINT OBJECT FOR LOCATIONS LIST
         const newPoint = {
           id: String(this.state.dragItems.length + 1),
           point: "Point " + (this.state.dragItems.length + 1),
           address: address,
           lat: lat,
           lng: lng,
           searchAddress: record.type === "geofence" ? "Geofence" : "Route"
         };
     
         // Add the new point in locations list
         const updatedList = [...this.state.dragItems, newPoint];
     
         await this.setState({
           dragItems: updatedList,
           selectedItemId: newPoint.id
         });
     
         // ----- ROUTE LOGIC -----
         if (updatedList.length === 1) {
           // First point = origin
           this.setState({
             origin: { lat, lng },
             destination: null,
             pointsWay: []
           });
         }
         else if (updatedList.length === 2) {
           // Second point = destination
           this.setState({
             destination: { lat, lng },
             pointsWay: []
           });
         }
         else if (updatedList.length > 2) {
           // 3rd, 4th etc = waypoints
           const wp = {
             location: { lat, lng },
             wayPointId: updatedList.length - 1
           };
     
           this.setState({
             pointsWay: [...this.state.pointsWay, wp]
           });
         }
     
         // Redraw route
         this.addWayPoints();
     
         setTimeout(() => {
           if (this.mapRef.current && this.mapRef.current.fitToMarkers) {
             this.mapRef.current.fitToMarkers();
           }
         }, 500);*/

    };
    addPointToMap = ({ lat, lng, address, type, name }) => {

        this.setState(prev => {

            const newPoint = {
                id: String(prev.dragItems.length + 1),
                point: name ? name : "Point " + (prev.dragItems.length + 1),
                address: address,
                lat: lat,
                lng: lng,
                searchAddress: type,
            };

            const updatedList = [...prev.dragItems, newPoint];

            let origin = prev.origin;
            let destination = prev.destination;
            let pointsWay = prev.pointsWay;

            // ✅ define local variables for addresses
            let originAddress = prev.originAddress || null;
            let destinationAddress = prev.destinationAddress || null

            if (updatedList.length === 1) {
                origin = { lat, lng };
                destination = null;
                originAddress = address;
                pointsWay = [];
            }
            else if (updatedList.length === 2) {
                destination = { lat, lng };
                destinationAddress = address;
                pointsWay = [];
            }
            else if (updatedList.length > 2) {
                const wp = {
                    id: updatedList.length + 1,       // NEW
                    ind: updatedList.length + 1,      // NEW
                    location: { lat, lng },
                    wayPointId: updatedList.length + 1,
                    address: address
                };
                pointsWay = [...prev.pointsWay, wp];

                console.log('pointsWay', pointsWay);
            }

            return {
                positionLatLongArray: [...prev.positionLatLongArray, { lat, lng }],
                dragItems: updatedList,
                selectedItemId: newPoint.id,
                origin,
                destination,
                pointsWay,
                originAddress,
                destinationAddress
            };

        }, () => {

            console.log("JOB ORDER SETSTATE TRIGGERED", this.state.dragItems);

            this.addWayPoints();

            setTimeout(() => {
                if (this.mapRef.current?.fitToMarkers) {
                    this.mapRef.current.fitToMarkers();
                }
            }, 500);
        });

    };
    addPointToMapOld = async ({ lat, lng, address, type }) => {

        // Add marker on map
        await this.setState({
            positionLatLongArray: [
                ...this.state.positionLatLongArray,
                { lat, lng }
            ]
        });

        // Create new point object
        const newPoint = {
            id: String(this.state.dragItems.length + 1),
            point: "Point " + (this.state.dragItems.length + 1),
            address: address,
            lat: lat,
            lng: lng,
            searchAddress: type
        };

        const updatedList = [...this.state.dragItems, newPoint];

        await this.setState({
            dragItems: updatedList,
            selectedItemId: newPoint.id
        });

        // -----------------------------
        // ORIGIN, DESTINATION, WAYPOINT
        // -----------------------------
        if (updatedList.length === 1) {
            this.setState({
                origin: { lat, lng },
                destination: null,
                pointsWay: []
            });
        }
        else if (updatedList.length === 2) {
            this.setState({
                destination: { lat, lng },
                pointsWay: []
            });
        }
        else if (updatedList.length > 2) {
            const wp = {
                location: { lat, lng },
                wayPointId: updatedList.length - 1
            };

            this.setState({
                pointsWay: [...this.state.pointsWay, wp]
            });
        }

        // Redraw on map
        this.addWayPoints();

        setTimeout(() => {
            if (this.mapRef.current && this.mapRef.current.fitToMarkers) {
                this.mapRef.current.fitToMarkers();
            }
        }, 500);
    };
    calculateCenterPoint = (coordinates) => {
        console.log(coordinates);
        if (coordinates && coordinates.length > 0) {
            const latSum = coordinates.reduce(
                (sum, point) => sum + point.latLong[0].lat,
                0
            );
            const lngSum = coordinates.reduce(
                (sum, point) => sum + point.latLong[0].lng,
                0
            );
            const latAvg = latSum / coordinates.length;
            const lngAvg = lngSum / coordinates.length;
            return { lat: latAvg, lng: lngAvg };
        }
        return null;
    };
    handleGeofencePlaceSelect = async (obj) => {
        console.log(obj);
        let placeDetails = obj;
        console.log(this.state.geofenceFormatedPoints);
        let centerPoint = await this.calculateCenterPoint(
            this.state.geofenceFormatedPoints
        );
        console.log(centerPoint);
        await this.setState({
            positionLatLongArray: [
                ...this.state.positionLatLongArray,
                { lat: centerPoint.lat, lng: centerPoint.lng },
            ],
        });

        await this.handleSetPlaces({
            address: placeDetails.address,
            latitude: centerPoint.lat,
            longitude: centerPoint.lng,
        });

        await this.setState({ update: 1 });

        // remaining

        //  let address = await this.assignJobOrderStore.getAddressUsingLatLng(centerPoint.lat,centerPoint.lng)
        //  console.log(address)
    };
    handleHistoryAddressSelect = async (obj) => {

        let placeDetails = obj;
        await this.setState({
            positionLatLongArray: [
                ...this.state.positionLatLongArray,
                { lat: Number(placeDetails.latitude), lng: Number(placeDetails.longitude) },
            ],
        });

        if (this.state.selectedItemId == "2") {
            this.setState({ destination: { lat: Number(placeDetails.latitude), lng: Number(placeDetails.longitude) } });
        }
        else if (this.state.selectedItemId == "1") {
            this.setState({ origin: { lat: Number(placeDetails.latitude), lng: Number(placeDetails.longitude) } });
        }

        const addressObject = {
            formattedAddress: placeDetails.stopIdleLocation,
            latitude: Number(placeDetails.latitude),
            longitude: Number(placeDetails.longitude),
        };
        //this.setState({ addressInputText: place.stopIdleLocation });
        this.handlePointsAddressChange(addressObject, "call");

    };
    handleHistoryPlaceSelect = (obj) => {
        console.log(obj);
        let placeDetails = obj;
        this.handleSetPlaces({
            address: placeDetails.stopIdleLocation,
            latitude: Number(placeDetails.latitude),
            longitude: Number(placeDetails.longitude),
        });
    };
    handleSetPlaces = async ({ address, latitude, longitude }) => {

        console.log(address, latitude, longitude, this.state.startPoint);
        console.log(this.state.start, this.state.end);
        if (this.state.startPoint) {
            const obj = {
                sequenceId: 1,
                routeZoneId: "ext-gen4321",
                routePoint: "Geofence",
                sequenceNo: "Start Point-" + address,
                pointName: address,
                address: address,
                lati: latitude,
                longi: longitude,
                arriveTime: null,
                departureTime: dayjs(
                    this.formRef.current.getFieldValue("startTime")
                ).format("HH:mm"),
                endTime: null,
                locOption: "Start-Time",
                time: dayjs(this.formRef.current.getFieldValue("startTime")).format(
                    "HH:mm"
                ),
            };
            console.log(obj);
            await this.setState({ startObj: obj });
            await this.setState({ update: 1 });
        } else if (this.state.endPoint) {
            const obj = {
                sequenceId: 2,
                routeZoneId: "ext-gen2264",
                routePoint: "Geofence",
                sequenceNo: "End Point-" + address,
                pointName: address,
                address: address,
                lati: latitude,
                longi: longitude,
                arriveTime: dayjs(this.formRef.current.getFieldValue("endTime")).format(
                    "HH:mm"
                ),
                departureTime: null,
                endTime: null,
                time: dayjs(this.formRef.current.getFieldValue("endTime")).format(
                    "HH:mm"
                ),
                locOption: "End-Time",
            };
            console.log("hello");
            this.setState({ endObj: obj });
        } else if (this.state.pickUpDrop) {
            await this.setState({ wayPointId: this.state.wayPointId + 1 });
            const obj = {
                routeZoneId: "ext-gen2264",
                routePoint: "Geofence",
                sequenceNo: "PickUp Point-" + address,
                pointName: address,
                address: address,
                lati: latitude,
                longi: longitude,
                arriveTime: null,
                departureTime: null,
                endTime: null,
                time: "00:00",
                locOption: "Pickup/Drop-Time",
                wayPointId: this.state.wayPointId,
            };

            await this.setState({ pickUpDropObj: obj });
            console.log([
                ...this.state.pointsWay,
                {
                    location: { lat: latitude, lng: longitude },
                    wayPointId: this.state.wayPointId,
                },
            ]);
            await this.setState({
                pointsWay: [
                    ...this.state.pointsWay,
                    {
                        location: {
                            lat: latitude,
                            lng: longitude,
                        },
                        wayPointId: this.state.wayPointId,
                    },
                ],
            });

            // this.setState({ pointsWay: [...this.state.pointsWay,{location:{lat:placeDetails.latitude,lng:placeDetails.longitude}}] });
        }

        // await this.setState({ geofencePointsArrayObj: formattedPoints });
        await this.setState({ loadState: 1 });
    };

    onDragEnd = (result) => {
        if (!result.destination) return;

        const draggedIndex = result.destination.index;

        const reordered = this.reorder(
            this.state.dragItems,
            result.source.index,
            result.destination.index
        );

        // STEP-1: dragItems update
        this.setState({ dragItems: reordered }, () => {

            // STEP-2: origin + destination set
            this.setState({
                origin: reordered.length
                    ? { lat: reordered[0].lat, lng: reordered[0].lng }
                    : null,

                destination: reordered.length > 1
                    ? {
                        lat: reordered[reordered.length - 1].lat,
                        lng: reordered[reordered.length - 1].lng
                    }
                    : null,

                originAddress: reordered.length ? reordered[0].address : null,
                destinationAddress: reordered.length > 1
                    ? reordered[reordered.length - 1].address : null,

                // STEP-3: WAYPOINTS SET CORRECTLY
                pointsWay:
                    reordered.length > 2
                        ? reordered.slice(1, -1).map((d, i) => ({
                            id: d.id,
                            wayPointId: i + 1,
                            location: { lat: d.lat, lng: d.lng },
                            address: d.address,   // ← THIS FIXES EVERYTHING
                        }))
                        : []
            }, () => {

                // STEP-4: now safely call addWayPoints
                if (reordered.length >= 3) {
                    this.addWayPoints();
                }

                if (this.mapRef?.current?.bounceMarker) {

                    let keyToBounce = null;

                    if (draggedIndex === 0) {
                        keyToBounce = "origin";
                    }
                    else if (draggedIndex === reordered.length - 1) {
                        keyToBounce = "destination";
                    }
                    else {
                        const waypoint = reordered[draggedIndex];
                        keyToBounce = `wp_${waypoint.id}`;
                    }

                    this.mapRef.current.bounceMarker(keyToBounce);
                }

            });

        });
    };

    onDragEndOld = (result) => {
        // dropped outside the list
        if (!result.destination) {
            return;
        }

        const dragItems = this.reorder(
            this.state.dragItems,
            result.source.index,
            result.destination.index
        );

        this.setState({
            dragItems
        }, () => {

            const originAddress = dragItems[0].address;
            const destinationAddress = dragItems.length > 1 ? dragItems[dragItems.length - 1].address : null;

            this.setState({ originAddress, destinationAddress }, () => {
                if (this.state.dragItems.length >= 3) {
                    this.addWayPoints();
                }
                this.handlePlaceSelected(null);
            });
        });
    };

    // a little function to help us with reordering the result
    reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        // result.forEach((item, index) => {
        //   item.index = index;
        // });

        return result;
    };


    handlePointsAddressChange = async (addressObject, param) => {
        let searchAdd = "";
        if (this.state.geofence) {
            searchAdd = "Geofence"
        }
        else if (this.state.searchOnMap) {
            searchAdd = "Search On Map"
        }
        else if (this.state.history) {
            searchAdd = "History"
        }

        this.setState((prevState) => {
            const updatedDragItems = prevState.dragItems.map((item) =>
                item.id === this.state.selectedItemId ? { ...item, address: addressObject.formattedAddress, lat: addressObject.latitude, lng: addressObject.longitude, searchAddress: searchAdd } : item
            );

            return { dragItems: updatedDragItems };
        }, () => {
            // Now that the state has been updated, call addWayPoints here
            if (param == "call") {
                if (this.state.dragItems.length >= 3) {
                    this.addWayPoints();
                }
            }


            this.handlePlaceSelected(null);

        });
    };

    addNewPoints = async (newAddress) => {     // On click of add new points button

        try {
            const lastRecord = this.state.dragItems[this.state.dragItems.length - 1];

            const newPoint = {
                id: String(Number(lastRecord.id) + 1),
                point: `Point ${String(Number(lastRecord.id) + 1)}`,
                address: "",
                lat: "",
                lng: ""
            };

            let id = String(Number(lastRecord.id) + 1);


            this.formRef.current.setFieldsValue({ pointName: newPoint.point });

            this.setState({ selectedItemId: id });

            this.setState({ addressInputText: "" });

            this.setState((prevState) => ({
                dragItems: [...prevState.dragItems, newPoint],
            }));
        } catch (error) {
            console.error("Error in addNewPoints:", error);
        }

    };

    addWayPoints = () => {
        console.log("addWayPoints");

        const items = this.state.dragItems;
        if (!items || items.length === 0) return;

        // ORIGIN
        const originItem = items[0];
        const origin = {
            lat: Number(originItem.lat),
            lng: Number(originItem.lng)
        };

        // DESTINATION
        const lastItem = items[items.length - 1];
        const destination =
            items.length > 1
                ? {
                    lat: Number(lastItem.lat),
                    lng: Number(lastItem.lng)
                }
                : null;

        // MIDDLE POINTS → WAYPOINTS (USE SAME ADDRESS ORDER)
        const middle = items.slice(1, -1);

        const pointsWay = middle.map((item, index) => ({
            id: item.id,                      // ← SAME ID
            ind: index + 1,
            wayPointId: index + 1,
            location: {
                lat: Number(item.lat),
                lng: Number(item.lng)
            },
            address: item.address            // ← SAME ADDRESS (NO CHANGE)
        }));

        this.setState({
            origin,
            originAddress: originItem.address,
            destination,
            destinationAddress: lastItem.address,
            pointsWay
        });

        console.log("JOB ORDER SETSTATE TRIGGERED waypoints", this.state.dragItems);

        console.log("Waypoints =>", pointsWay);
    };

    addWayPoints_129 = async () => {
        console.log("addWayPoints");

        const items = this.state.dragItems;

        if (!items || items.length === 0) return;

        const originItem = items[0];
        const destinationItem = items[items.length - 1];
        const middleItems = items.slice(1, -1); // middle points with correct address

        // SET ORIGIN + ADDRESS
        const origin = {
            lat: Number(originItem.lat),
            lng: Number(originItem.lng)
        };

        // SET DESTINATION + ADDRESS (ONLY IF >1 POINT)
        const destination =
            items.length > 1
                ? {
                    lat: Number(destinationItem.lat),
                    lng: Number(destinationItem.lng)
                }
                : null;

        // MAP MIDDLE POINTS → WAYPOINTS (PRESERVE ADDRESS)
        const pointsWay = middleItems.map((rec, index) => ({
            id: index + 1,
            ind: index + 1,
            wayPointId: index + 1,
            location: {
                lat: Number(rec.lat),
                lng: Number(rec.lng)
            },
            address: rec.address // 🔥 IMPORTANT → address preserved
        }));

        this.setState({
            origin: origin,
            originAddress: originItem.address,

            destination: destination,
            destinationAddress: destinationItem.address,

            pointsWay: pointsWay,
            loadState: 1
        });

        console.log("origin =>", originItem.address);
        console.log("destination =>", destinationItem.address);
        console.log("waypoints =>", pointsWay);
    };
    addWayPointsold1 = async () => {

        console.log('addWayPoints');

        const items = this.state.dragItems;

        // Always set origin = first point
        const firstRec = items[0];
        this.setState({
            origin: {
                lat: Number(firstRec.lat),
                lng: Number(firstRec.lng)
            }
        });


        if (items.length >= 2) {
            const lastRec = items[items.length - 1];

            this.setState({
                destination: {
                    lat: Number(lastRec.lat),
                    lng: Number(lastRec.lng)
                }
            });
        } else {

            this.setState({ destination: null });
        }

        // Waypoints only if more than 2 points
        const middlePoints = items.slice(1, -1);

        const wayPoints = middlePoints.map((rec, index) => ({
            id: index + 1,
            ind: index + 1,
            wayPointId: index + 1,
            location: { lat: Number(rec.lat), lng: Number(rec.lng) },
            // wayPointId: index + 2,
            address: rec.address
        }));

        this.setState({ pointsWay: wayPoints });

        this.setState({ loadState: 1 });

        console.log("origin**", this.state.origin);
        console.log("destination**", this.state.destination);
    };
    addWayPointsOld = async () => {

        console.log('addWayPoints');
        var firstRec = this.state.dragItems[0];

        this.setState({ origin: { lat: Number(firstRec.lat), lng: Number(firstRec.lng) } });

        var middlePoints = this.state.dragItems.slice(1, -1);

        var lastRec = this.state.dragItems[this.state.dragItems.length - 1];

        this.setState({ destination: { lat: Number(lastRec.lat), lng: Number(lastRec.lng) } });

        await this.setState({
            //wayPointId: prevState.wayPointId + 1,
            pointsWay: [],
        });

        const wayPoints = await middlePoints.map((record, index) => {

            const pointsway = {
                location: {
                    lat: Number(record.lat),
                    lng: Number(record.lng),
                },
                wayPointId: index + 2
            };

            return pointsway;

        });

        console.log("wayPoints**", wayPoints);

        await this.setState({ pointsWay: wayPoints });

        console.log("origin**", this.state.origin);

        console.log("destination**", this.state.destination);

        await this.setState({ loadState: 1 });
    }

    Showhidecomp = (index) => {

        if (index == 0) {

            this.setState({ startPoint: true });
            this.setState({ endPoint: false });
            this.setState({ pickUpDrop: false });

        } else if (index == this.state.dragItems.length - 1) {

            this.setState({ startPoint: false });
            this.setState({ endPoint: true });
            this.setState({ pickUpDrop: false });

        } else {
            this.setState({ startPoint: false });
            this.setState({ endPoint: false });
            this.setState({ pickUpDrop: true });
        }

    }


    handleDeletePointsOld = async (e, itemId) => {
        e.stopPropagation(); // Prevent the click event from triggering the parent div's onClick

        // Filter out the item with the specified itemId
        const updatedDragItems = this.state.dragItems.filter(item => item.id !== itemId);

        // Update the state with the new array
        await this.setState({ dragItems: updatedDragItems });

        console.log("dragItemsondelete", this.state.dragItems);
    };
    handleBlur = (e) => {
        console.log("Input blurred:", e.target.value);
        // You can perform any other actions you want on blur
    }

    handleStopsSourceChange = async (values) => {
        const companyId = this.state.companyId;
        let finalList = [];

        if (!companyId) {
            message.warning("Please select Account first");
            return;
        }

        // POINTS SELECTED → getPoi()
        if (values.includes("4")) {
            const poiResp = await this.AssignRouteStore.getPoi(companyId);
            console.log(poiResp)
            if (poiResp?.data?.data) {
                const mappedPoi = poiResp.data.data.map((item) => ({
                    zoneId: item.poiId,
                    name: item.name,
                    address: item.address,
                    points: item.points,
                    type: "poi",
                    lat: item.latitude,
                    long: item.longitude
                }))
                finalList = [...finalList, ...mappedPoi];
            }
        }


        if (values.includes("2")) {
            const poiResp = await this.assignJobOrderStore.getRouteList(companyId);

            const routes = poiResp?.data?.data?.routeslist?.map((item, index) => ({
                zoneId: item.routeId,
                name: item.routeName,
                address: "",
                routePoints: item.RoutePoints,
                type: "route",
            })) || [];

            finalList.push(...routes);
        }

        // GEOFENCES SELECTED → getGeoData()
        if (values.includes("3")) {
            const geoResp = await this.assignJobOrderStore.getGeoData(companyId);
            if (geoResp?.data?.geofence) {

                const mappedGeofence = geoResp.data.geofence.map((item) => {

                    let lat = null, lng = null;

                    if (item.points) {
                        const arr = item.points.split(",");
                        lat = Number(arr[0]);
                        lng = Number(arr[1]);
                    }

                    return {
                        zoneId: item.zoneId,
                        name: item.name || "Geofence",
                        address: item.address || "",
                        points: item.points,
                        lat: lat,
                        lng: lng,
                        type: "geofence",
                    };
                });

                finalList = [...finalList, ...mappedGeofence];
            }
        }

        // ALL SELECTED → both APIs
        if (values.includes("1")) {
            const poiResp = await this.assignJobOrderStore.getRouteList(companyId);
            const geoResp = await this.assignJobOrderStore.getGeoData(companyId);

            const routes = poiResp?.data?.data?.routeslist?.map((item) => ({
                zoneId: item.routeId,
                name: item.routeName,
                address: item.address || "",
                lat: Number(item.latitude) || null,
                lng: Number(item.longitude) || null,
                routePoints: item.RoutePoints,

                type: "route",
            })) || [];


            if (geoResp?.data?.geofence) {
                const mappedGeofence = geoResp.data.geofence.map((item) => {

                    let lat = null, lng = null;

                    if (item.points) {
                        const arr = item.points.split(",");
                        lat = Number(arr[0]);
                        lng = Number(arr[1]);
                    }

                    return {
                        zoneId: item.zoneId,
                        name: item.name || "Geofence",
                        address: item.address || "",
                        points: item.points,
                        lat: lat,
                        lng: lng,
                        type: "geofence",
                    };
                });


                finalList = [...routes, ...mappedGeofence];

            }
        }

        this.setState({ sourcesList: finalList });
    }

    updateDistanceTime = (distance, time, hours, minutes) => {

        this.setState({
            travelDistance: distance,
            travelDuration: time,
            travelHours: hours,
            travelMinutes: minutes
        },
            () => {

                const id = this.props.params.id;
                if (id) {
                    return;
                } else {
                    this.calculateEndDateTime();
                }

            }
        );
    };
    calculateEndDateTime = () => {
        try {
            const hours = this.state.travelHours || 0;
            const minutes = this.state.travelMinutes || 0;
            const currentdttime = dayjs();

            if (hours === 0 && minutes === 0) {
                this.formRef.current.setFieldsValue({
                    plannedEndDateTime: currentdttime
                });
                return;
            }





            this.formRef.current.setFieldsValue({
                plannedStartDateTime: currentdttime
            });


            const newEnd = currentdttime.add(hours, "hour").add(minutes, "minute");

            this.formRef.current.setFieldsValue({
                plannedEndDateTime: newEnd
            });

            setTimeout(() => {
                if (this.scrollRef.current) {
                    this.scrollRef.current.scrollTo({ top: 0, behavior: "smooth" });
                }
            }, 100);

        } catch (e) {
            console.log("Error calculating end datetime", e);
        }
    };
    calculateEndDateTimeold = () => {
        try {
            const start = this.formRef.current.getFieldValue("plannedStartDateTime");
            const hours = this.state.travelHours || 0;
            const minutes = this.state.travelMinutes || 0;

            if (!start || (hours === 0 && minutes === 0)) return;

            const newEnd = dayjs(start)
                .add(hours, "hour")
                .add(minutes, "minute");

            this.formRef.current.setFieldsValue({
                plannedEndDateTime: newEnd
            });

            setTimeout(() => {
                if (this.scrollRef.current) {
                    this.scrollRef.current.scrollTo({ top: 0, behavior: "smooth" });
                }
            }, 100);

        } catch (e) {
            console.log("Error calculating end datetime", e);
        }
    };
    formatAddress = (sequenceNo) => {
        if (!sequenceNo) return "";

        // Split only on the first dash
        const firstDashIndex = sequenceNo.indexOf("-");

        if (firstDashIndex === -1) return sequenceNo; // no dash found

        return sequenceNo.substring(firstDashIndex + 1).trim();
    };

    updateUnitDriverDisableState = (unitsSelected) => {
        const disable = unitsSelected?.length > 1;

        this.setState({
            driversDisabled: disable,
            mainDriverDisabled: disable,
        });
    };
    handleDeletePointsol1 = async (e, id) => {
        const newList = this.state.dragItems.filter(x => x.id !== id);

        // Update dragItems first
        await this.setState({ dragItems: newList });

        // Recalculate origin
        const origin =
            newList.length >= 1
                ? { lat: newList[0].lat, lng: newList[0].lng }
                : null;

        // Recalculate destination
        const destination =
            newList.length >= 2
                ? {
                    lat: newList[newList.length - 1].lat,
                    lng: newList[newList.length - 1].lng,
                }
                : null;

        // Recalculate waypoints
        const pointsWay =
            newList.length > 2
                ? newList.slice(1, newList.length - 1).map((p, i) => ({
                    id: p.id,
                    wayPointId: i + 1,
                    location: { lat: p.lat, lng: p.lng },
                }))
                : [];

        // Set updated values
        await this.setState({
            origin,
            destination,
            pointsWay,
        });

        // If route cannot be drawn anymore, remove polyline
        if (!origin || !destination) {
            this.setState({ directonResponse: null });
        }
    };
    handleDeletePoints = async (e, id) => {
        const { dragItems, routePoints, geofencePointsArrayObj } = this.state;

        // Filter out the deleted point
        const newDragItems = dragItems.filter(x => x.id !== id);
        const newRoutePoints = routePoints?.filter(x => x.id !== id);
        const newGeofencePoints = geofencePointsArrayObj?.filter(x => x.sequenceId !== id);

        // Update dragItems
        await this.setState({
            dragItems: newDragItems,
            routePoints: newRoutePoints,
            geofencePointsArrayObj: newGeofencePoints,
        });

        // Recalculate origin
        const origin = newDragItems.length >= 1 ? { lat: newDragItems[0].lat, lng: newDragItems[0].lng } : null;



        // Recalculate destination
        const destination =
            newDragItems.length >= 2
                ? { lat: newDragItems[newDragItems.length - 1].lat, lng: newDragItems[newDragItems.length - 1].lng }
                : null;

        // ☑️ Recalculate ADDRESSES
        const originAddress = newDragItems.length >= 1
            ? newDragItems[0].address
            : null;

        const destinationAddress = newDragItems.length >= 2
            ? newDragItems[newDragItems.length - 1].address
            : null;

        // Recalculate waypoints
        const pointsWay =
            newDragItems.length > 2
                ? newDragItems.slice(1, -1).map((p, i) => ({
                    id: p.id,
                    wayPointId: i + 1,
                    location: { lat: p.lat, lng: p.lng },
                    address: p.address
                }))
                : [];

        await this.setState({ origin, destination, pointsWay, originAddress, destinationAddress });

        // Remove polyline if not enough points
        if (!origin || !destination) {
            this.setState({ directonResponse: null });
        }

        this.addWayPoints();
    };

    handleDeleteMarkerClick = (markerObj) => {
        this.setState({
            isDeleteModalVisible: true,
            selectedMarkerToDelete: markerObj
        });
    };

    handleDeleteMarker = (marker) => {
        if (marker.type === "origin") {
            this.setState({ origin: null });
        }
        else if (marker.type === "destination") {
            this.setState({ destination: null });
        }
        else if (marker.type === "waypoint") {
            const updated = this.state.pointsWay.filter(
                p => p.wayPointId !== marker.wayPointId
            );
            this.setState({ pointsWay: updated });
        }
    };

    recalculateMapRoutes = () => {
        const arr = this.state.dragItems;

        this.setState({
            origin: arr[0] ? { lat: arr[0].lat, lng: arr[0].lng } : null,
            destination:
                arr.length > 1
                    ? { lat: arr[arr.length - 1].lat, lng: arr[arr.length - 1].lng }
                    : null,
            pointsWay:
                arr.length > 2
                    ? arr.slice(1, arr.length - 1).map((p, i) => ({
                        location: { lat: p.lat, lng: p.lng },
                        wayPointId: i + 1,
                    }))
                    : [],
        });
    };

    setUnitsByGroup = async (groupIds) => {
        try {
            const vehicleList = await this.assignJobOrderStore.getUnitsByGroup(groupIds, this.state.companyId);

            this.setState({
                vehicleList: vehicleList || [],
            });

        } catch (err) {
            console.log("Error in setUnitsByGroup", err);
            this.setState({ loadingUnits: false });
        }
    }



    render() {
        return (
            <>
                <GoogleMapForDirection
                    origin={this.state.origin}
                    destination={this.state.destination}
                    wayPoints={this.state.pointsWay}
                    onPlaceSelected={this.handlePlaceSelected}
                    geofencePointsArrayObj={this.state.geofencePointsArrayObj}
                    This={this}
                    positions={this.state.positionLatLongArray}
                    mapRef={this.mapRef}
                    updateDistanceTime={this.updateDistanceTime}
                    disableDragging={true}
                    handleDeletePoints={this.handleDeletePoints}
                    isIconVisible={true}
                    routeColor="#2196F3"
                    enableNewDistanceLogic={true}
                ></GoogleMapForDirection>
                {/* <div className="assign-trip-details-panel"> */}
                {/* <div className="formBorder"> */}
                {/* <div className="headingTitle"> Create/Assign Trip</div> */}
                {/* <Row style={{ padding: "24px" }}> */}


                <Form
                    ref={this.formRef}
                    style={{ padding: 0 }}
                    layout="vertical"
                    onFinish={this.onFinish}
                    // {...this.layout}

                    name="nest-message"
                    initialValues={{
                        fromDate: dayjs(),
                        toDate: dayjs(),
                        validFrom: dayjs(),
                        validTo: dayjs(),
                        routestartDate: dayjs(),
                        routestopDate: dayjs(),
                        startTime: dayjs("00:00", "HH:mm"),
                        endTime: dayjs("00:00", "HH:mm"),
                    }}
                >
                    {/* <h1>Create/Assign Trip</h1> */}

                    <div style={{ display: "flex" }}>
                        <Spin spinning={this.state.loadingSpinner}>
                            <div
                                className="leftWhite-form-panel"
                                style={{
                                    width: 350,
                                    height: "calc(100vh)",
                                    display: "flex",
                                    flexDirection: "column",
                                    background: "#fff",
                                    borderRight: "1px solid #ddd"
                                }}
                            >

                                {/* TITLE FIXED */}
                                <div
                                    style={{
                                        padding: "12px 15px",
                                        borderBottom: "1px solid #e6e6e6",
                                        fontSize: 18,
                                        fontWeight: 600
                                    }}
                                >
                                    Create Job Order
                                </div>

                                {/* SCROLLABLE CONTENT */}
                                <div
                                    ref={this.scrollRef}
                                    style={{
                                        flex: 1,
                                        overflowY: "auto",
                                        padding: "10px 15px",
                                    }}
                                >

                                    <Collapse defaultActiveKey={["1"]} style={{ marginBottom: 15 }}>
                                        <Collapse.Panel header="Main Details" key="1">
                                            <div style={{ marginTop: -18 }}>
                                                {/* <Form layout="vertical"> */}
                                                {(this.props.getUserData().isadmin === -1 ||
                                                    this.props.getUserData().isadmin === 3) && (
                                                        <Form.Item name="account" label="Account" rules={[{ required: true }]}>
                                                            {/* <Select placeholder="Select Account" /> */}
                                                            <CompanyAutocomplete
                                                                onChange={(val) => this.handleChange(val)}
                                                                style={{ width: "100%" }}
                                                                companyId={this.state.companyId}
                                                            />
                                                        </Form.Item>
                                                    )}

                                                <Form.Item name="tripName" label="Trip Name" rules={[{ required: true }]}>
                                                    <Input placeholder="Enter Trip Name" />
                                                </Form.Item>

                                                <Form.Item
                                                    name="plannedStartDateTime"
                                                    label="Planned Start Date & Time"
                                                    rules={[{ required: true }]}
                                                    initialValue={dayjs()}
                                                >
                                                    <DatePicker
                                                        showTime={{ use12Hours: true }}
                                                        style={{ width: "100%" }}
                                                        format="YYYY-MM-DD HH:mm"
                                                    />
                                                </Form.Item>

                                                <Form.Item
                                                    name="plannedEndDateTime"
                                                    label="Planned End Date & Time"
                                                    rules={[{ required: true }]}
                                                    initialValue={dayjs()}
                                                >
                                                    <DatePicker
                                                        showTime={{ use12Hours: true }}
                                                        style={{ width: "100%" }}
                                                        format="YYYY-MM-DD HH:mm"
                                                    />
                                                </Form.Item>

                                                <Form.Item name="unitGroup" label="Unit Group" rules={[{ required: false }]}>
                                                    <Select
                                                        mode="multiple"
                                                        placeholder="Select Unit Group"
                                                        onChange={(val, option) => {
                                                            // Set selected group
                                                            this.setState({ selectedUnitGroup: val });

                                                            // Load units based on selected group
                                                            this.setUnitsByGroup(val);
                                                        }}
                                                    >
                                                        {this.state.deviceGroupList.map((g) => (
                                                            <Select.Option key={g.deviceGroupId} value={g.deviceGroupId} obj={g}>
                                                                {g.groupname}
                                                            </Select.Option>
                                                        ))}
                                                    </Select>
                                                </Form.Item>

                                                <Form.Item name="units" label="Units" rules={[{ required: false }]}>
                                                    <Select
                                                        mode="multiple"
                                                        placeholder="Select Units"
                                                        showSearch
                                                        rules={[{ required: true }]}
                                                        optionFilterProp="children"
                                                        onChange={(selectedUnits) => {
                                                            this.updateUnitDriverDisableState(selectedUnits);
                                                            const disable = selectedUnits.length > 1;

                                                            this.setState({ driverRequired: !disable });

                                                            if (disable) {
                                                                // Reset driver fields
                                                                this.formRef.current.setFieldsValue({
                                                                    assignedDrivers: [],
                                                                    mainDriver: undefined
                                                                });

                                                                this.setState({
                                                                    assignedDriversList: [],
                                                                    mainDriver: null
                                                                });
                                                            }
                                                        }}

                                                    >
                                                        {this.state.vehicleList.map((u) => (
                                                            <Select.Option key={u.vehicleId} value={u.vehicleId} obj={u}>
                                                                {u.vehicleName || u.vehicleNo}
                                                            </Select.Option>
                                                        ))}
                                                    </Select>
                                                </Form.Item>

                                                <Form.Item name="assignedDrivers" label="Assigned Drivers" rules={[{ required: this.state.driverRequired, message: "Assigned Drivers required when selecting single unit" }]}>
                                                    <Select
                                                        mode="multiple"
                                                        disabled={this.state.driversDisabled}
                                                        placeholder="Select Drivers"
                                                        onChange={(selectedDrivers, optionList) => {

                                                            const driverObjects = optionList.map(o => o.obj);

                                                            // Update available main driver list
                                                            this.setState({ assignedDriversList: driverObjects });

                                                            // Auto select only when single driver
                                                            if (driverObjects.length === 1) {
                                                                this.formRef.current.setFieldsValue({
                                                                    mainDriver: driverObjects[0].driverId
                                                                });
                                                                this.setState({ mainDriver: driverObjects[0].driverId });
                                                            }

                                                            // If removed driver = remove from mainDriver
                                                            if (
                                                                this.state.mainDriver &&
                                                                !driverObjects.find(d => d.driverId === this.state.mainDriver)
                                                            ) {
                                                                this.formRef.current.setFieldsValue({ mainDriver: undefined });
                                                                this.setState({ mainDriver: null });
                                                            }
                                                        }}
                                                        showSearch
                                                        optionFilterProp="children"
                                                    >
                                                        {this.state.driverList.map((d) => (
                                                            <Select.Option key={d.driverId} value={d.driverId} obj={d}>
                                                                {d.driverName}
                                                            </Select.Option>
                                                        ))}
                                                    </Select>
                                                </Form.Item>

                                                <Form.Item name="mainDriver" label="Main Driver" rules={[{ required: false }]}>
                                                    <Select
                                                        disabled={this.state.mainDriverDisabled}
                                                        placeholder="Select Main Driver"
                                                        onChange={(val) => this.setState({ mainDriver: val })}
                                                    >
                                                        {this.state.assignedDriversList.map((d) => (
                                                            <Select.Option key={d.driverId} value={d.driverId}>
                                                                {d.driverName}
                                                            </Select.Option>
                                                        ))}
                                                    </Select>
                                                </Form.Item>

                                                <Form.Item name="tripStatus" label="Trip Status" rules={[{ required: true }]}>
                                                    <Select placeholder="Select Status">
                                                        <Select.Option value={1}>Allocate to Driver</Select.Option>
                                                        <Select.Option value={2}>Assigned by Admin</Select.Option>
                                                    </Select>
                                                </Form.Item>

                                                {/* </Form> */}
                                            </div>
                                        </Collapse.Panel>
                                    </Collapse>

                                    {/* ROUTE POINTS PANEL */}
                                    <Collapse defaultActiveKey={["2"]}>
                                        <Collapse.Panel header="Set Route Points" key="2">

                                            <div style={{ marginTop: -18 }}>

                                                <Form.Item name="stopSource" label="Stops Source" rules={[{ required: true }]}>
                                                    <Select
                                                        mode="multiple"
                                                        placeholder="Select stops source"
                                                        onChange={this.handleStopsSourceChange}
                                                    >
                                                        <Select.Option value="1">All</Select.Option>
                                                        <Select.Option value="2">Routes</Select.Option>
                                                        <Select.Option value="3">Geofences</Select.Option>
                                                        <Select.Option value="4">Points</Select.Option>
                                                    </Select>
                                                </Form.Item>

                                                <Form.Item name="sourceType" label="Source" rules={[{ required: false }]}>
                                                    <Select placeholder="Select Source"
                                                        showSearch
                                                        onSelect={async (val, e) => {
                                                            await this.handleGeofenceObj(e.obj);
                                                        }}
                                                        filterOption={(inputValue, option) => {
                                                            return (
                                                                option.children
                                                                    .toLowerCase()
                                                                    .indexOf(inputValue.toLowerCase()) >= 0
                                                            );
                                                        }}
                                                    >
                                                        {this.state.sourcesList.map((item, idx) => (
                                                            <Select.Option key={idx} value={item.id} obj={item}>
                                                                {item.name}
                                                            </Select.Option>
                                                        ))}
                                                    </Select>
                                                </Form.Item>
                                                {/* </Form> */}

                                                {/* LOCATIONS */}
                                                <div className="add-checkpoint-wrapper">
                                                    <DragDropContext onDragEnd={this.onDragEnd}>
                                                        <Droppable droppableId="droppable">
                                                            {(provided) => (
                                                                <div
                                                                    className="add-checkpoint-inner"
                                                                    {...provided.droppableProps}
                                                                    ref={provided.innerRef}
                                                                >


                                                                    {/* 🔥 EMPTY LIST PLACEHOLDER MESSAGE */}
                                                                    {this.state.dragItems.length === 0 && (
                                                                        <div
                                                                            style={{
                                                                                textAlign: "center",
                                                                                padding: "20px 10px",
                                                                                color: "#999",
                                                                                fontSize: 14,
                                                                                fontStyle: "italic"
                                                                            }}
                                                                        >
                                                                            Your selected locations will appear here
                                                                        </div>
                                                                    )}


                                                                    {this.state.dragItems.map((item, index) => (
                                                                        <Draggable key={item.id} draggableId={item.id} index={index}>
                                                                            {(provided_) => (
                                                                                <div
                                                                                    ref={provided_.innerRef}
                                                                                    {...provided_.draggableProps}
                                                                                    {...provided_.dragHandleProps}
                                                                                    className={
                                                                                        this.state.selectedItemId === item.id
                                                                                            ? "checkpoint-list active-checkpoint"
                                                                                            : "checkpoint-list"
                                                                                    }
                                                                                    onClick={() => {
                                                                                        this.setState({ selectedItemId: item.id });
                                                                                        this.setState({ addressInputText: item.address });
                                                                                        this.formRef.current.setFieldsValue({ pointName: item.point });
                                                                                        this.Showhidecomp(index);
                                                                                    }}
                                                                                >
                                                                                    {/* {this.state.dragItems.length > 2 && ( */}
                                                                                    <Popconfirm
                                                                                        title="Delete this point?"
                                                                                        onConfirm={(e) => this.handleDeletePoints(e, item.id)}
                                                                                        okText="Yes"
                                                                                        cancelText="No"
                                                                                    >
                                                                                        <div className="checkpoint-close">
                                                                                            <CloseOutlined />
                                                                                        </div>
                                                                                    </Popconfirm>
                                                                                    {/* )} */}

                                                                                    <span>{index + 1}</span>
                                                                                    <p>
                                                                                        <b>{item.point}</b>
                                                                                        <small>
                                                                                            {item.address === ""
                                                                                                ? " Address not specified"
                                                                                                : item.address}
                                                                                        </small>
                                                                                    </p>
                                                                                </div>
                                                                            )}
                                                                        </Draggable>
                                                                    ))}

                                                                    {provided.placeholder}
                                                                </div>
                                                            )}
                                                        </Droppable>
                                                    </DragDropContext>
                                                </div>

                                                {/* OPTIMIZE BOX */}
                                                <div
                                                    style={{
                                                        marginTop: 20,
                                                        padding: 15,
                                                        border: "1px solid #e0e0e0",
                                                        borderRadius: 8,
                                                        background: "#f7f7f7",
                                                    }}
                                                >
                                                    <h4 style={{ marginBottom: 10 }}>Tap to Optimize</h4>

                                                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                        <span>Distance:</span>
                                                        <b>{this.state.travelDistance || "—"}</b>
                                                    </div>

                                                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                        <span>Time:</span>
                                                        <b>{this.state.travelDuration || "—"}</b>
                                                    </div>


                                                </div>
                                            </div>
                                        </Collapse.Panel>
                                    </Collapse>

                                </div>

                                {/* FIXED BOTTOM BUTTONS */}
                                <div
                                    style={{
                                        padding: "12px 15px",
                                        borderTop: "1px solid #ddd",
                                        background: "#fff",
                                        display: "flex",
                                        gap: 10,
                                        position: "sticky",
                                        bottom: 0,
                                        zIndex: 999,
                                    }}
                                >
                                    <Button
                                        style={{ width: "50%" }}
                                        onClick={() => this.props.navigate("/assignjoborderlist")}
                                    >
                                        Cancel
                                    </Button>

                                    <Button
                                        type="primary"
                                        style={{ width: "50%" }}
                                        htmlType="submit"
                                    >
                                        Save
                                    </Button>
                                </div>

                            </div>
                        </Spin>
                    </div>

                </Form>

                {/* </div> */}
                {/* </div> */}
            </>
        );
    }
}

AssignJobOrderAddNew.contextType = StoreContext;
export default observer(withRouter(AssignJobOrderAddNew));